// Mock data for Brinckmann Arbeitsbühnen - Apple-style redesign

export const companyInfo = {
  name: "Brinckmann",
  subtitle: "Arbeitsbühnen",
  fullName: "Brinckmann Arbeitsbühnen GmbH",
  phone: "02871 / 242 660",
  email: "info@brinckmann-arbeitsbuehnen.de",
  address: "Ruhrallee 13, 46395 Bocholt",
  tagline: "Mieten ist Vertrauenssache",
  heroTitle: "hoch und weit\nmit Sicherheit",
  heroSubtitle: "Bundesweite Vermietung von Arbeitsbühnen – professionell, zuverlässig und immer für Sie da.",
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Über uns", href: "#about" },
  { label: "Geräte", href: "#equipment" },
  { label: "Schulungen", href: "/schulungen" },
  { label: "Leistungen", href: "#services" },
  { label: "Partner", href: "#partners" },
  { label: "Kontakt", href: "#contact" },
];

export const equipmentCategories = [
  {
    id: 1,
    name: "Scherenbühnen",
    description: "Große, ebene Plattform für Arbeiten in der Höhe – stabil, wendig und ideal für Innen- und Außeneinsätze.",
    image: "/uploads/k11jemoh_Scherenbuehne.jpg",
    specs: ["Arbeitshöhe bis 20 m", "Elektro & Diesel", "Indoor & Outdoor"],
    useCases: [
      "Lager- und Logistikhallen, Regal- und Deckenwartung",
      "Elektro-, Sanitär- und Lüftungsinstallation",
      "Maler-, Trockenbau- und Ausbauarbeiten",
      "Messe- und Veranstaltungsaufbau",
      "Wartung in Produktionsstätten",
    ],
  },
  {
    id: 2,
    name: "Gelenkteleskopbühnen",
    description: "Beweglicher Arm für Höhe und seitliche Reichweite zugleich – ideal, um Hindernisse zu überwinden.",
    image: "/uploads/bvh6ftvh_Gelenkteleskopbuehne.jpg",
    specs: ["Arbeitshöhe bis 45 m", "Seitliche Reichweite", "Hindernisse überwinden"],
    useCases: [
      "Arbeiten über Rohrleitungen, Dächern oder Bäumen",
      "Fassaden mit Vor- und Rücksprüngen",
      "Industrieanlagen und Raffinerien",
      "Brückeninspektion und -wartung",
      "Einsätze mit engen Zufahrten, innen wie außen",
    ],
  },
  {
    id: 3,
    name: "Teleskopbühnen",
    description: "Maximale Höhe und Reichweite in gerader Linie – die richtige Wahl für große Distanzen im Außenbereich.",
    image: "/uploads/igpmbhqn_Teleskopbuehne.jpg",
    specs: ["Arbeitshöhe bis 43 m", "Große Reichweite", "Outdoor"],
    useCases: [
      "Fassadenarbeiten und Fensterreinigung",
      "Dach- und Hallenbau",
      "Freileitungs- und Beleuchtungsmontage",
      "Baustellenlogistik im Außenbereich",
      "Stahlbau und Industriemontage",
    ],
  },
  {
    id: 4,
    name: "Spezial-Arbeitsbühnen",
    description: "Für Einsätze, bei denen Standardgeräte an ihre Grenzen kommen – z. B. mit Raupenfahrwerk oder als Anhängerbühne.",
    image: "/uploads/n638ygwt_ChatGPT-Image-15.-Apr.-2026-09_39_54.jpg",
    specs: ["Arbeitshöhe bis 50 m", "Raupen- & Anhängerbühnen", "Individuelle Lösungen"],
    useCases: [
      "Unwegsames und unebenes Gelände",
      "Innenhöfe und Flächen mit begrenzter Tragfähigkeit",
      "Denkmalgeschützte und historische Gebäude",
      "Flexibler Einsatz ohne Führerschein Klasse C",
      "Gärten, Parks und schwer zugängliche Innenräume",
    ],
  },
  {
    id: 5,
    name: "LKW-Arbeitsbühnen",
    description: "Straßenzugelassen und schnell vor Ort – für Einsätze mit häufigem Standortwechsel und großer Reichweite.",
    image: "/uploads/12li1hgt_LKW-Arbeitsbuehne.jpg",
    specs: ["Arbeitshöhe bis 100 m", "Hohe Reichweite", "Schneller Standortwechsel"],
    useCases: [
      "Straßenbeleuchtung und Ampelanlagen",
      "Baumpflege im öffentlichen Raum",
      "Leitungs- und Kabelarbeiten",
      "Kommunale Einsätze mit wechselnden Standorten",
      "Großflächige Fassaden- und Werbetechnik",
    ],
  },
  {
    id: 6,
    name: "Teleskopstapler",
    description: "Kran und Stapler in einem – für Materialtransport auf unebenem Gelände. Die Roto-Variante ist 360° drehbar und arbeitet rund ums Gebäude ohne Standortwechsel.",
    image: "/uploads/x97n9ocz_Teleskopstapler2.jpg",
    specs: ["Hubhöhe bis 39 m", "Tragkraft bis 12 t", "Roto: 360° drehbar"],
    useCases: [
      "Materialtransport und Be-/Entladen auf unebenem Gelände",
      "Einsätze in der Landwirtschaft",
      "Flexibel mit Anbaugeräten: Schaufel, Kran-Ausleger, Arbeitskorb",
      "Roto: Kran- und Staplerfunktion in einem (360° drehbar)",
      "Dach- und Fassadenarbeiten auf beengten Baustellen – ohne Standortwechsel",
    ],
  },
  {
    id: 7,
    name: "Gabelstapler",
    description: "Zuverlässiger Transport und Umschlag von Lasten – das Arbeitstier für Lager, Baustelle und Produktion.",
    image: "/uploads/m6ih74lk_Gabelstapler-1.jpg",
    specs: ["Diesel & Elektro", "Tragkraft bis 16,0 t", "Indoor & Outdoor"],
    useCases: [
      "Be- und Entladen von LKW",
      "Palettentransport im Lager",
      "Kommissionierung und Warenumschlag",
      "Baustellenlogistik",
      "Materialver- und -entsorgung in der Produktion",
    ],
  },
];

export const features = [
  {
    title: "Fachkundige Beratung",
    description: "Unsere Experten beraten Sie kompetent bei der Auswahl des richtigen Gerätes.",
    icon: "MessageCircle",
  },
  {
    title: "Jahrelange Erfahrung",
    description: "Profitieren Sie von unserer langjährigen Branchenerfahrung und Expertise.",
    icon: "Award",
  },
  {
    title: "Individuelle Lösungen",
    description: "Maßgeschneiderte Lösungen für jeden Einsatz – stets kundennah.",
    icon: "Settings",
  },
  {
    title: "Schnelle Verfügbarkeit",
    description: "24 Stunden erreichbar. Schnelle Bereitstellung bundesweit.",
    icon: "Clock",
  },
  {
    title: "Hochwertige Geräte",
    description: "Ausschließlich Geräte von namhaften und qualitativ hochwertigen Herstellern.",
    icon: "Shield",
  },
  {
    title: "IPAF Schulungen",
    description: "Vielseitiges Schulungsangebot für den sicheren Umgang mit Arbeitsbühnen.",
    icon: "GraduationCap",
  },
];

export const teamMembers = [
  {
    name: "Nils Terstegge",
    role: "Vermietung",
    email: "n.terstegge@brinckmann-arbeitsbuehnen.de",
    phone: "02871 / 242 660",
    image: "/uploads/c72xymfa_Nils-Terstegge-web.jpg",
    whatsapp: "492871242660",
  },
  {
    name: "Reu Kowalski",
    role: "Disposition",
    email: "r.kowalski@brinckmann-arbeitsbuehnen.de",
    phone: "02871 / 242 660",
    image: "/uploads/hdchfdnp_Reu-Kowalski-web.jpg",
    whatsapp: "492871242660",
  },
  {
    name: "Lars Mengering",
    role: "Vertrieb",
    email: "l.mengering@brinckmann-arbeitsbuehnen.de",
    phone: "02871 / 242 660",
    image: "/uploads/qhy8cd7i_Lars-Mengering-web.jpg",
    whatsapp: "492871242660",
  },
  {
    name: "Zoran Paripovic",
    role: "Transport",
    email: "z.paripovic@brinckmann-arbeitsbuehnen.de",
    phone: "02871 / 242 660",
    image: null,
  },
];

export const partnerLogos = [
  { name: "JLG", url: "/uploads/jlg1.png" },
  { name: "IPAF", url: "/uploads/ipaf1.png" },
  { name: "PartnerLIFT", url: "/uploads/partnerlift.png" },
  { name: "OperatorCARD", url: "/uploads/Logo_OC.png" },
];

export const aboutText = {
  heading: "Mieten ist Vertrauenssache",
  paragraph1: "Als junges und dynamisches Unternehmen bieten wir Ihnen sämtliche Leistungen rund um die Vermietung von Arbeitsbühnen und Maschinen aus einer Hand. Unser Ziel ist es, Ihre Arbeitsabläufe so effizient, sicher und wirtschaftlich wie möglich zu gestalten.",
  paragraph2: "Dabei setzen wir konsequent auf Qualität und Zuverlässigkeit. Deshalb umfasst unser Mietpark ausschließlich moderne Geräte namhafter und bewährter Hersteller der Branche. So können Sie sich jederzeit auf leistungsfähige Technik und eine professionelle Durchführung Ihrer Arbeiten verlassen.",
  highlight: "Bundesweite Vermietung: Ein Anruf genügt.",
  cta: "Egal wann, wo und welches Gerät – wir erfüllen Ihnen jeden Wunsch!",
};

export const bookingOptions = {
  types: [
    "Scherenbühne",
    "Teleskopbühne",
    "Gelenkteleskopbühne",
    "LKW-Arbeitsbühne",
    "Spezialarbeitsbühne",
    "Teleskopstapler",
  ],
  times: [
    "06:00", "06:30", "07:00", "07:30", "08:00", "08:30",
    "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
    "12:00", "12:30", "13:00", "13:30", "14:00", "14:30",
    "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00",
  ],
};

export const stats = [
  { value: "15.000+", label: "Arbeitsbühnen im Netzwerk" },
  { value: "24/7", label: "Erreichbarkeit" },
  { value: "100%", label: "Bundesweite Abdeckung" },
  { value: "15+", label: "Jahre Erfahrung" },
];
